import { Injectable } from '@angular/core';
import { ActionSheetController } from '@ionic/angular';
import { ActionSheetButton, OverlayEventDetail } from '@ionic/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { TranslateService } from '@ngx-translate/core';
import { Tool } from '@services/tools';

@Injectable()
export class MediaToolsProviderService {
  private readonly mediaTools: Tool[] = [];

  constructor(private actionSheetController: ActionSheetController, private translate: TranslateService) {}

  getMediaTools(): Tool[] {
    return this.mediaTools;
  }

  register(mediaTool: Tool) {
    this.mediaTools.push(mediaTool);
    this.mediaTools.sort((a, b) => a.priority - b.priority);
  }

  open(callcard: CallCard): Promise<OverlayEventDetail> {
    const actionSheetButtons = this.mediaTools.map(tool => this.createButton(tool));
    return this.actionSheetController
      .create({ header: this.translate.instant('Saga.AttachmentsType'), buttons: actionSheetButtons })
      .then(actionSheet =>
        actionSheet.present().then(() => actionSheet.onDidDismiss().then(overlayEvent => this.execute(callcard, overlayEvent)))
      );
  }

  private execute(callcard: CallCard, overlayEvent: OverlayEventDetail): OverlayEventDetail {
    if (overlayEvent.role !== 'backdrop') {
      this.mediaTools.find(tool => tool.text === overlayEvent.role).handler({ callcard: callcard });
    }
    return overlayEvent;
  }

  private createButton(tool: Tool): ActionSheetButton {
    return {
      text: this.translate.instant(tool.text),
      role: tool.text
    };
  }
}
